
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hardware/meetingBoard",
      function () {
        return require("private-next-pages/hardware/meetingBoard/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hardware/meetingBoard"])
      });
    }
  